import { useEffect } from 'react';

import ViewManager from '../view';

const useViewUpdate = (callBack, dependencies) => {
  useEffect(() => {
    function onViewUpdate(event) {
      callBack(event);
    }
    ViewManager.on(ViewManager.EVENT_UPDATE, onViewUpdate);
    return () => {
      ViewManager.off(ViewManager.EVENT_UPDATE, onViewUpdate);
    };
  }, dependencies);
};

export default useViewUpdate;
